import { all, call, cancelled, put, takeLatest } from "redux-saga/effects"
import { push } from "connected-react-router"
import axios from "axios"
import {
  GET_EXPORT_REPORT_WATCHER,
  GET_MEDITIONS_REPORT_EXPORT_WATCHER,
  GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER,
} from "./constants"
import {
  exportReportFailed,
  exportReportSuccess,
  getMeditionsReportExportSuccess,
  getDivisionsAmbassadorReportExportWatcher,
  getDivisionsAmbassadorReportExportSuccess,
} from "./actions"

import { LOCAL_TOKEN } from "../../../utils/storage"

function getMeditionsExportApi(params) {
  const url = "reports/measure/officialized/"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function getDivisionsAmbassadorExportApi(params) {
  const url = `action-plans/divisions/ambassador?searchByIdMeasure=${params.searchByIdMeasure}`
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function exportApi(params) {
  const url = `reports/measure/${params.measure_id}/officialized/export/${params.type}`
  return axios.request({
    method: "POST",
    url: `${process.env.API_URL + url}`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
  })
}

function exportPresentationApi(params) {
  const url = `reports/measure/${params.measure_id}/export/presentation`
  return axios.request({
    method: "POST",
    url: `${process.env.API_URL + url}`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
  })
}

export function* getMeditionsExportSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const [meditionsApi] = yield all([
      call(getMeditionsExportApi, params.payload),
    ])
    const result = {}
    result.meditions = meditionsApi.data.data.measures
    result.configuration = {
      ambassador_qualitative_results_visible:
        meditionsApi.data.data.ambassador_qualitative_results_visible,
    }
    if (result.meditions.length === 0) {
      yield put(push("/error"))
    }

    yield put(getMeditionsReportExportSuccess(result))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getDivisionsAmbasadorExportSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const [divisionsAmbassador] = yield all([
      call(getDivisionsAmbassadorExportApi, params.payload),
    ])
    const result = {}
    result.divisions = divisionsAmbassador.data.data.result
    yield put(getDivisionsAmbassadorReportExportSuccess(result))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* exportSaga(params) {
  if (typeof params.payload.presentation !== "undefined") {
    try {
      const message = yield call(exportPresentationApi, params.payload)
      const result = {}
      yield put(exportReportSuccess(result))
    } catch (e) {
      yield put(exportReportFailed())
    }
  } else {
   /*  var win = undefined
    window.oldOpen = window.open
    let openWin
    if (params.payload.type === "pdf") {
      var win = window.open("")
      openWin = function (url) { // eslint-disable-line
        // reassignment function
        if (url) {
          win.location = url
          window.open = oldOpen
        }
      }
    } */
    try {
      const exportApis = yield call(exportApi, params.payload)
      const result = {}
     /*  if (params.payload.type === "pdf") {
        openWin(exportApis.data.data.result.url, "_blank")
        returnMessage(exportApis)
        win.focus()
        result.url = exportApis.data.data.result.url
      } else {
        result.url = ""
      } */
      yield put(exportReportSuccess(result))
    } catch (e) {
      if (win) {
        win.close()
      }
      returnMessage(e)
      yield put(exportReportFailed())
    }
  }
}

// Individual exports for testing
export default function* reportsPageSaga() {
  // yield takeLatest(GET_MEDITIONS_WATCHER, getMeditionsSaga);
  // yield takeLatest(OFFICIALIZE_MEDITIONS_WATCHER, officializeSaga);
  yield takeLatest(GET_MEDITIONS_REPORT_EXPORT_WATCHER, getMeditionsExportSaga)
  yield takeLatest(
    GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER,
    getDivisionsAmbasadorExportSaga
  )

  yield takeLatest(GET_EXPORT_REPORT_WATCHER, exportSaga)
  // See example in containers/HomePage/saga.js
}
